import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Arranqué nadando 25m con descanso. A las 12 semanas hice 1.500m sin parar y bajé mi 5k de 28:40 a 26:10. El plan es exigente pero realista para alguien con dos hijos y oficina.',
  name: 'Martín Sosa',
  role: 'Buenos Aires'
}, {
  quote: 'En 4 meses pasé de 42 min los 10k a 39:20, y sumé bici sin perder ritmo de running. Lo más útil fue la planilla semanal: dejé de improvisar y los entrenos rinden el doble.',
  name: 'Laura Giménez',
  role: 'Rosario'
}, {
  quote: 'Hice mi primer Sprint en 1h 32m con apenas 5 a 6 hs por semana. La calculadora de hidratación me ahorró calambres en la transición bici-running, algo que antes me arruinaba todo.',
  name: 'Diego Martínez',
  role: 'Córdoba'
}, {
  quote: 'Soy médico, hago guardias y pensé que no me daba el tiempo. En 5 meses preparé un Olímpico y lo terminé en 2h 48m. La guía de suplementos me ahorró comprar 3 cosas que no servían.',
  name: 'Federico Álvarez',
  role: 'Mendoza'
}, {
  quote: 'Bajé 4 kg, sumé 2 km/h promedio en bici (de 26 a 28) y mi natación pasó de 2:15/100m a 1:58/100m. Todo siguiendo las 6 hs semanales sin descuidar el laburo ni la familia.',
  name: 'Carolina Pérez',
  role: 'Mar del Plata'
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-dark" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="text-center mb-16" data-id="element-131">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-132">
            Lo que dicen quienes ya entrenan
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-133">
            Resultados reales de argentinos que decidieron optimizar su tiempo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-134">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-white/5 backdrop-blur-sm rounded-2xl p-7 border border-white/10" data-id="element-135">
              <div className="flex gap-1 mb-4 text-brand-green" data-id="element-136">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} fill="currentColor" data-id="element-137" />)}
              </div>
              <p className="font-serif italic text-lg text-white mb-6 leading-relaxed" data-id="element-138">
                "{t.quote}"
              </p>
              <div data-id="element-139">
                <p className="font-bold text-white" data-id="element-140">{t.name}</p>
                <p className="text-sm text-white/60" data-id="element-141">{t.role}, Argentina</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}